import { render } from "./messageCardImage.vue?vue&type=template&id=3a9344b8&scoped=true"
import script from "./messageCardImage.vue?vue&type=script&lang=js"
export * from "./messageCardImage.vue?vue&type=script&lang=js"

import "./messageCardImage.vue?vue&type=style&index=0&id=3a9344b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9344b8"]])

export default __exports__